import { render } from "./VideoPlayer.vue?vue&type=template&id=ffe06a38&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=ffe06a38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe06a38"]])

export default __exports__